import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import type { NexysShareFeaturePage } from 'config/nexysShareFeatures'
import { useEffect, useState } from 'react'
import { Modal } from 'stories/components'

interface Props {
  featureKey: string
  featureTitle: string
  peerTitle: string
  pages: NexysShareFeaturePage[]
  pagePermissions: Record<string, boolean>
  onClose: () => void
  onSave: (pagePermissions: Record<string, boolean>) => void
}

export const NexysPeerPagePermissionsModal = ({
  featureKey,
  featureTitle,
  peerTitle,
  pages,
  pagePermissions,
  onClose,
  onSave,
}: Props) => {
  const [visibleStatus, setVisibleStatus] = useState<Record<string, boolean>>({})

  useEffect(() => {
    const initial: Record<string, boolean> = {}
    pages.forEach((page) => {
      initial[page.key] = pagePermissions?.[page.key] !== false
    })
    setVisibleStatus(initial)
  }, [featureKey, pages, pagePermissions])

  const onToggle = (key: string) => {
    const next = cloneDeep(visibleStatus)
    next[key] = !next[key]
    setVisibleStatus(next)
  }

  return (
    <Modal
      title={`${featureTitle} Page Permissions for ${peerTitle}`}
      titleOkay="Save"
      titleCancel="Close"
      isOpen
      onClose={onClose}
      onOk={() => {
        const next: Record<string, boolean> = {}
        pages.forEach((page) => {
          next[page.key] = visibleStatus[page.key] !== false
        })
        onSave(next)
        return true
      }}
    >
      <div className="max-h-[60vh] overflow-auto space-y-2">
        {pages.map((page, index) => {
          const isActive = visibleStatus[page.key] !== false
          const EIcon = isActive ? EyeIcon : EyeSlashIcon
          return (
            <div
              key={page.key}
              className={`flex items-center gap-2 cursor-pointer hover:underline ${isActive ? '' : 'opacity-50 line-through'}`}
              onClick={() => onToggle(page.key)}
            >
              <span>
                {index + 1}. {page.title}
              </span>
              <EIcon className="w-4 h-4 text-shade-blue" />
            </div>
          )
        })}
      </div>
    </Modal>
  )
}
